import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function updateEquipmentFiles(equipmentId, filesBase64, finalFilesIds, prefix) {
    const token = await getOrRefreshFirebaseToken();

    const formData = new FormData();
    if (!Array.isArray(filesBase64) || filesBase64.length === 0) {
        formData.append('files', ''); // Handle case with no files
    }
    else {
        filesBase64.forEach((file) => {
            formData.append('files', file);
        });
    }
    finalFilesIds.forEach((id) => {
        formData.append('finalFilesIds', id);
    });

    const res = await axios.post(
        `${prefix}equipments/${equipmentId}/files`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
            },
        }
    );
    
    return res.data;
}